<template>
    <div class="div tooltip" :data-tooltip="carData.query.shipping_line">
        <button class="button is-small text-button" :class="{'bold' : isFilled}" @click="openModal" style="min-width: 55px;">
            {{ carData.query.shipping_line }}
        </button>
        <div class="modal" :class="{'is-active': isActive }">
            <div class="modal-background" @click="isActive = !isActive"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Shipping Line: {{ carData.query.shipping_line }}</p>
                    <button class="delete" aria-label="close" @click="isActive = !isActive"></button>
                </header>
                <section class="modal-card-body">
                    <div class="field has-addons">
                        <div class="control is-expanded">
                            <input v-model="carData.query.shipping_line_url" class="input" type="text" placeholder="Shipping line link.">
                        </div>
                        <div class="control">
                            <button @click="saveUrl" :class="{'is-loading' : isLoading}" class="button is-primary">
                                Save
                            </button>
                        </div>
                    </div>
                    <table class="is-fullwidth table is-bordered is-striped">
                        <thead>
                        <tr>
                            <th width="10">Select</th>
                            <th>Name</th>
                            <th>Link</th>
                            <th width="10" colspan="2">Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(line, index) in lines">
                            <td width="10">
                                <button class="button is-info" @click="selectLine(line)">
                                        <span class="icon">
                                          <i class="fas fa-check"></i>
                                        </span>
                                </button>
                            </td>
                            <td class="subtitle">
                                <input v-if="selectedLine.id === line.id" class="input" v-model="selectedLine.name " type="text" placeholder="Line name">
                                <span v-else>{{ line.name }}</span>
                            </td>
                            <td class="subtitle">
                                <input v-if="selectedLine.id === line.id" class="input" v-model="selectedLine.link " type="text" placeholder="Line link">
                                <span v-else>{{ line.link }}</span>
                            </td>
                            <td width="10">
                                <button v-if="selectedLine.id === line.id" class="button is-primary" @click="updateLine">
                                        <span class="icon">
                                          <i class="fas fa-save"></i>
                                        </span>
                                </button>
                                <button v-else class="button is-info" @click="editLine(line)">
                                        <span class="icon">
                                          <i class="fas fa-edit"></i>
                                        </span>
                                </button>
                            </td>
                            <td width="10">
                                <button class="button is-danger" @click="deleteLine(index, line)">
                                        <span class="icon">
                                          <i class="fas fa-trash"></i>
                                        </span>
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <input v-model="shippingLine.name" class="input" type="text" placeholder="Type name of the line">
                            </td>
                            <td colspan="2">
                                <input v-model="shippingLine.link" class="input" type="text" placeholder="Type link of the line">
                            </td>
                            <td width="10">
                                <button class="button is-primary" @click="createNewPort">
                                    <span class="icon">
                                        <i class="fas fa-save"></i>
                                    </span>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </section>
                <footer class="modal-card-foot">
                    <button class="button"  @click="isActive = !isActive">Close</button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import apiShippingLines from './../../../api/apiShippingLines'
    import apiCars from './../../../api/apiCars'
    import moment from 'moment'
    export default {
        props:['car'],
        components: {

        },
        data () {
            return {
                isActive: false,
                isLoading: false,
                lines: [],
                carData:{
                    id: this.car.id,
                    query: {
                        shipping_line: this.car.shipping_line === null ? '---' : this.car.shipping_line,
                        shipping_line_url: this.car.shipping_line_url
                    }
                },
                shippingLine: {
                    name: null,
                    link: null
                },
                selectedLine: {
                    id: null,
                    name: null,
                    link: null
                }
            }
        },
        methods: {
            editLine(line) {
                this.selectedLine = line
            },
            updateLine() {
                apiShippingLines
                    .updateShippingLineRequest(this.selectedLine)
                    .then((response) => {
                        this.fetchLines()
                        this.selectedLine = {
                            id: null,
                            name: null,
                            link: null
                        }
                    })
                    .catch(error => console.log(error))
            },
            createNewPort(){
                apiShippingLines
                    .createShippingLineRequest(this.shippingLine)
                    .then((response) => {
                        this.lines.push(response.data)
                        this.shippingLine.name = ''
                    })
                    .catch(error => console.log(error))
            },
            selectLine(line) {
                this.isLoading = true
                this.carData.query.shipping_line = line.name
                this.carData.query.shipping_line_url = line.link
                apiCars
                    .updateCarRequest(this.carData)
                    .then((response) => {
                        this.isActive = false
                        this.isLoading = false
                        this.$store.dispatch('fetchCarsWithSearchQuery')
                    })
                    .catch(error => console.log(error))
            },
            saveUrl() {
                this.isLoading = true
                apiCars
                    .updateCarRequest(this.carData)
                    .then((response) => {
                        this.isLoading = false
                        this.$store.dispatch('fetchCarsWithSearchQuery')
                    })
                    .catch(error => {
                        this.isLoading = false
                        console.log(error)
                    })
            },
            deleteLine(index, line){
                apiShippingLines
                    .deleteShippingLineRequest(line.id)
                    .then((response) => {
                        this.lines = this.lines.filter(item => item !== line)
                        this.shippingLine.name = ''
                    })
                    .catch(error => console.log(error))
            },
            openModal() {
                this.isActive = !this.isActive
                this.fetchLines()
            },
            fetchLines() {
                apiShippingLines
                    .shippingLinesListRequest()
                    .then((response) => {
                        this.lines = response.data
                    })
                    .catch(error => console.log(error))
            }
        },
        computed: {
            isFilled() {
                if (this.carData.query.shipping_line !== '---'){
                    return  true;
                }
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>
    .text-button {
        max-width: 100px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>



// WEBPACK FOOTER //
// src/components/Cars/Columns/ShippingLineColumn.vue